<template>
    <div>
        <template v-if="!loading">
            <template v-if="pBank">
                <div class="grid grid-cols-2 md:grid-cols-4">
                    <button
                        v-for="category in parents"
                        class="flex flex-col items-center justify-center border-r border-gray-100 last:border-r-0 p-6"
                        @click="showDetail(category.id)"
                    >
                        <div
                            class="relative flex items-start justify-center w-full h-full max-w-64 max-h-64"
                        >
                            <PrepCategoryReportDonut
                                :name="category.category"
                                :correct="
                                    $options.methods.optional(
                                        categories[category.id],
                                        'questions_correct'
                                    )
                                "
                                :total="
                                    $options.methods.optional(
                                        categories[category.id],
                                        'questions_total'
                                    )
                                "
                            />
                        </div>
                        <div
                            class="text-lg md:text-xl font-medium md:font-normal font-light space-y-2 mt-6"
                        >
                            <div class="flex items-center justify-center">
                                {{ category.category }}
                            </div>
                            <div class="flex items-center justify-center">
                                <div
                                    v-if="
                                        $options.methods.optional(
                                            categories[category.id],
                                            'questions_total'
                                        ) > 0
                                    "
                                    class="inline-flex items-center justify-center bg-gray-100 border border-gray-200 text-sm leading-8 rounded-md space-x-1 px-4"
                                >
                                    <span
                                        v-text="
                                            $options.methods.optional(
                                                categories[category.id],
                                                'questions_correct'
                                            )
                                        "
                                    />
                                    <span>/</span>
                                    <span
                                        v-text="
                                            $options.methods.optional(
                                                categories[category.id],
                                                'questions_total'
                                            )
                                        "
                                    />
                                    <span class="font-medium pl-1"
                                        >correct</span
                                    >
                                </div>
                                <div
                                    v-else
                                    class="inline-flex items-center justify-center bg-gray-100 border border-gray-200 text-sm leading-8 rounded-md space-x-1 px-4"
                                >
                                    No questions
                                </div>
                            </div>
                        </div>
                    </button>
                </div>
            </template>
            <template v-else>
                <div class="flex items-center justify-center h-40">
                    For detailed reporting, please choose a question bank
                </div>
            </template>
        </template>
        <PrepCategoryReportModal
            :active="showModal"
            :category="detailCategory"
            @close="hideModal"
        />
    </div>
</template>

<script lang="ts">
import axios from "axios";

export default {
    props: {
        bank: String,
        exam: Number,
        rows: Array,
    },
    data(): any {
        return {
            pBank: "Radiography",
            banks: {},
            categories: [],
            detailCategoryId: null,
            loading: true,
            showModal: false,
        };
    },
    computed: {
        detailCategory() {
            if (!this.detailCategoryId) {
                return {};
            }

            let structure = this.banks[this.pBank];
            let categories = this.categories;

            return {
                name: structure.filter((o) => o.id == this.detailCategoryId)[0]
                    .category,
                rows: structure
                    .filter((o) => o.parent_id == this.detailCategoryId)
                    .map((o) => {
                        return {
                            name: o.category,
                            questions_correct: this.$options.methods.optional(
                                categories[o.id],
                                "questions_correct"
                            ),
                            questions_total: this.$options.methods.optional(
                                categories[o.id],
                                "questions_total"
                            ),
                            children: structure
                                .filter((a) => a.parent_id == o.id)
                                .map((a) => {
                                    return {
                                        name: a.category,
                                        questions_correct:
                                            this.$options.methods.optional(
                                                categories[a.id],
                                                "questions_correct"
                                            ),
                                        questions_total:
                                            this.$options.methods.optional(
                                                categories[a.id],
                                                "questions_total"
                                            ),
                                    };
                                }),
                        };
                    }),
            };
        },
        hasCategories() {
            return Object.keys(this.categories).length > 0;
        },
        rowIds() {
            return this.exam
                ? [parseInt(this.exam)]
                : this.rows.map((o) => o.id);
        },
        activeBank() {
            return Object.keys(this.banks).length > 0
                ? this.banks[this.pBank]
                : null;
        },
        parents() {
            return this.activeBank && this.hasCategories
                ? this.activeBank.filter((o) => o.parent_id == null)
                : [];
        },
    },
    methods: {
        getData() {
            this.loading = true;
            this.categories = [];
            axios
                .post("/api/pulse/prep-categories", {
                    exams: this.rowIds,
                })
                .then((response) => {
                    this.categories = response.data;
                    this.loading = false;
                });
        },
        getStructure() {
            axios.get("/api/pulse/prep-category-structure").then((response) => {
                this.banks = response.data;
            });
        },
        hideModal() {
            this.showModal = false;
            this.detailCategoryId = null;
        },
        showDetail(categoryId) {
            this.detailCategoryId = categoryId;
            this.showModal = true;
        },
    },
    mounted() {
        this.getStructure();
        this.getData();
        this.pBank = this.bank || this.pBank;
    },
};
</script>
